import { combineReducers } from "redux";
import LoadingReducer from "./loadingReducer";
import ErrorReducer from "./errorReducer";
import ConfigReducers from "./ConfigReducers";
import UserReducers from "./UserReducers";
import BreadcrumbReducers from "./BreadcrumbReducers";
import SiteReducers from "pages/Site/reducers";
import StoreReducers from "pages/Store/reducers";

const appReducer = combineReducers({
  error: ErrorReducer,
  loading: LoadingReducer,
  configs: ConfigReducers,
  user: UserReducers,
  site: SiteReducers,
  store: StoreReducers,
  breadcrumb: BreadcrumbReducers,
});

const rootReducer = (state, action) => {
  // if (action.type === actions.userTypes.LOG_OUT) {
  //   state = undefined;
  // }
  return appReducer(state, action);
};

export default rootReducer;
